import './App.css';

import {Header} from './components/Header'
import {NavPanel} from './components/NavPanel'
import {SubNav} from './components/SubNav'

import {About} from './pages/about'
import {Summary} from './pages/summary'
import {Details} from './pages/details'
import {Mobile} from './pages/mobile'
import {PageTitle} from "./components/PageTitle/PageTitle";
import * as i18nDict  from "./components/i18n";
import {getLocale} from "./components/i18n/i18nHelper";

import {BrowserRouter as Router, Routes, Route, Navigate, useLocation, useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";

function FirstVisitGate({ children }) {

    const navigate = useNavigate();

    useEffect(() => {

        const visited = sessionStorage.getItem("entryChecked");

        if (!visited) {

            sessionStorage.setItem("entryChecked", "true");

            const isMobile =
                /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
                    .test(navigator.userAgent) ||
                (navigator.maxTouchPoints > 1 &&
                    window.innerWidth < 768);

            if (isMobile) {
                navigate("/view/mobile", { replace: true });
            }
        }

    }, [navigate]);

    return children;
}

function wrapPage(component, i18n) {
    return(
        <FirstVisitGate>
            <div className={"centered-content"}>

                <div className={"title-text"}>
                    {i18n.Title}
                </div>

                <div className={"column-flex"}>

                    <NavPanel i18n={i18n}/>

                    <div className={'main-content'}>
                        <div className={"subtitle-text"}>
                            {i18n.Subtitle}
                        </div>
                        <SubNav i18n={i18n}/>

                        <PageTitle i18n={i18n}/>
                        {component}
                    </div>
                </div>
            </div>
        </FirstVisitGate>
    )
}

function mobileWrapPage(component, i18n) {
    return(
            <div className={"centered-content"}>

                <div className={"title-text"}>
                    {i18n.Title}
                </div>

                <div className={"column-flex"}>

                    <NavPanel i18n={i18n}/>

                    <div className={'main-content'}>
                        {component}
                    </div>
                </div>
            </div>
    )
}

function App() {

    const [locale, setLocale] = useState(getLocale());
    const i18n = i18nDict[locale];
  return (
      <Router>
      <div>
        <Header/>

        <div className="App">
            <Routes>
                <Route
                    path="/view/about"
                    element={ wrapPage(<About i18n={i18n}/>, i18n)}
                />

                <Route
                    path="/view/details"
                    element={wrapPage(<Details i18n={i18n}/>, i18n)}
                />

                <Route
                    path="/view/summary"
                    element={wrapPage(<Summary i18n={i18n}/>, i18n)}
                />

                <Route
                    path="/view/mobile"
                    element={mobileWrapPage(<Mobile i18n={i18n}/>, i18n)}
                />

                <Route path="*" element={<Navigate to="/view/about" replace />} />
            </Routes>
        </div>

      </div>
      </Router>

  );
}

export default App;
